import React from "react";
import "./about.css";
import { FaJava } from "react-icons/fa";
import { HiDesktopComputer } from "react-icons/hi";
import { SiAdobeaftereffects } from "react-icons/si";
import CV from "../../assets/cv.pdf";

const About = () => {
  return (
    <section id="about">
      <h5> Sobre mis</h5>
      <h2> Estudios</h2>

      <div className="container">
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <HiDesktopComputer className="about__icon" />
              <h5> Sistemas microinformáticos y Redes</h5>
              <small>Finalizado y con experiencia</small>
            </article>

            <article className="about__card">
              <FaJava className="about__icon" />
              <h5> Desarrollo de aplicaciones multiplataforma</h5>
              <small>Actualmente cursando</small>
            </article>

            <article className="about__card">
              <SiAdobeaftereffects className="about__icon" /> 
              <h5> Edición de vídeo e imagen</h5>
              <small>
                Finalizado y con experiencia (AfterEffects, Premiere, Photoshop){" "}
              </small>
            </article>
          </div>

          <div className="about__info">
            <p>En cuanto a mis estudios realizados se incluyen: </p>
            <h4> Grado medio en Sistemas Microinformáticos y Redes</h4>
            <h4>
              Grado superior en Desarrollo de aplicaciones multiplataforma
              (cursando actualmente)
            </h4>
            <h4>
              Cursos certificados de After Effects, Premiere Pro, Photoshop
            </h4>
          </div>

          <p>
            Para más información
            <a href={CV} download className="cv-download">
              {" "}
              descargue{" "}
            </a>
            el CV
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
